import { render, staticRenderFns } from "./DashboardFinanceiro.vue?vue&type=template&id=8bd0748c"
import script from "./DashboardFinanceiro.vue?vue&type=script&lang=js"
export * from "./DashboardFinanceiro.vue?vue&type=script&lang=js"
import style0 from "./DashboardFinanceiro.vue?vue&type=style&index=0&id=8bd0748c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports